import { useEffect, useRef } from "react";
import {
  trackPublicCatalogueView,
  type PublicCatalogueAnalyticsPayload,
} from "../../../utils/cataloguePublicAnalytics";

/** Fires dual GA once per catalogue + share link after public-status loads. */
export function usePublicCatalogueAnalytics(payload: PublicCatalogueAnalyticsPayload): void {
  const key = [
    payload.catalogueId,
    payload.linkToken || "",
    payload.organizationId || "",
    payload.studioMeasurementId || "",
  ].join("|");
  const sent = useRef("");

  useEffect(() => {
    if (!payload.catalogueId || !payload.linkToken) {
      return;
    }
    if (sent.current === key) {
      return;
    }
    sent.current = key;
    trackPublicCatalogueView(payload);
  }, [key, payload.catalogueId, payload.linkToken]);
}
